import { Avatar } from '@mui/material'
import { stringAvatar } from '../../util/constants'

const UserAvatar = ({ profile_image, name, sx = undefined }: any) => {
  const userFirst = stringAvatar(name)?.toUpperCase()

  return <>{profile_image ? <Avatar alt={userFirst} src={profile_image} /> : <Avatar>{userFirst}</Avatar>}</>
}
export default UserAvatar
